import type { ComponentType, ReactNode } from "react";
import type { UserRole } from "@/src/auth/types/auth.types";

export interface SettingsSection {
	id: string;
	title: ReactNode;
	description?: ReactNode;
	order?: number;
	/** Optional role filter. When set, only listed roles see this section. */
	roles?: readonly UserRole[];
	component: ComponentType;
}

const sections = new Map<string, SettingsSection>();

/**
 * Domain teammates register their settings panes here. Safe to call
 * multiple times (last write wins). Order is stable by `order` then `id`.
 */
export function registerSettingsSection(section: SettingsSection): void {
	sections.set(section.id, section);
}

export function getSettingsSections(role?: UserRole | null): SettingsSection[] {
	return Array.from(sections.values())
		.filter((section) => !section.roles || (role !== null && role !== undefined && section.roles.includes(role)))
		.sort((a, b) => {
			const aOrder = a.order ?? 100;
			const bOrder = b.order ?? 100;
			if (aOrder !== bOrder) return aOrder - bOrder;
			return a.id.localeCompare(b.id);
		});
}
